const finished=new Set(['FT','AET','PEN','AWD','WO']);
const utcTime=value=>{
 if(typeof value!=='string')return NaN;
 return Date.parse(/[zZ]|[+-]\d\d:\d\d$/.test(value)?value:value+'Z');
};

/** Display-only completed result. Never a live feed, settlement or stored prediction. */
export function recordedFixture(primary,analytics){
 const p=analytics?.profile,r=analytics?.recorded_presentation;
 if(!primary||analytics?.status!=='AVAILABLE'||p?.status!=='finished'||r?.scope!=='completed_match_display_only')return primary;
 if(String(primary.id)!==String(p.csb_fixture_id)||String(primary.provider_fixture_id)!==String(p.api_football_fixture_id))return primary;
 const kickoff=utcTime(primary.kickoff_utc),observed=utcTime(p.observed_at);
 if(!Number.isFinite(kickoff)||kickoff!==utcTime(p.kickoff_utc)||!Number.isFinite(observed)||observed<kickoff)return primary;
 if(!Number.isInteger(p.home_goals)||!Number.isInteger(p.away_goals)||p.home_goals<0||p.away_goals<0)return primary;
 const finalPrimary=finished.has(String(primary.status_short || primary.status).toUpperCase());
 if(finalPrimary&&(Number(primary.home_score)!==p.home_goals||Number(primary.away_score)!==p.away_goals))return primary;
 return {...primary,status:'FT',status_short:'FT',status_long:'Match Finished',elapsed:null,home_score:p.home_goals,away_score:p.away_goals,
  lineups:primary.lineups?.length?primary.lineups:r.lineups,
  events:r.events?.length?r.events:primary.events,
  recorded_display_source:'pitchapi',recorded_lineup_source:r.lineup_source,recorded_display_observed_at:p.observed_at};
}
